var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectViewId(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 133,
    viewBox: "0 0 130 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 130C100.899 130 130 100.899 130 65C130 29.1015 100.899 0 65 0C29.1015 0 0 29.1015 0 65C0 100.899 29.1015 130 65 130Z",
    fill: "#EAECF0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4723_27838)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4723_27838",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 130,
    height: 130
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 130C100.899 130 130 100.899 130 65C130 29.1015 100.899 0 65 0C29.1015 0 0 29.1015 0 65C0 100.899 29.1015 130 65 130Z",
    fill: "url(#paint0_linear_4723_27838)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4723_27838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.267 37.2656H27.7337C25.3405 37.2656 23.4004 39.2057 23.4004 41.599V132.599C23.4004 134.992 25.3405 136.932 27.7337 136.932H102.267C104.66 136.932 106.6 134.992 106.6 132.599V41.599C106.6 39.2057 104.66 37.2656 102.267 37.2656Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1997 45.9297H34.6664C33.2305 45.9297 32.0664 47.0937 32.0664 48.5297C32.0664 49.9656 33.2305 51.1297 34.6664 51.1297H57.1997C58.6357 51.1297 59.7997 49.9656 59.7997 48.5297C59.7997 47.0937 58.6357 45.9297 57.1997 45.9297Z",
    fill: "#EAECF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1997 82.3359H34.6664C33.2305 82.3359 32.0664 83.5 32.0664 84.9359C32.0664 86.3719 33.2305 87.5359 34.6664 87.5359H57.1997C58.6357 87.5359 59.7997 86.3719 59.7997 84.9359C59.7997 83.5 58.6357 82.3359 57.1997 82.3359Z",
    fill: "#EAECF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6003 58.9297H36.4003C34.4857 58.9297 32.9336 60.4818 32.9336 62.3964V71.063C32.9336 72.9776 34.4857 74.5297 36.4003 74.5297H93.6003C95.5149 74.5297 97.0669 72.9776 97.0669 71.063V62.3964C97.0669 60.4818 95.5149 58.9297 93.6003 58.9297Z",
    stroke: "#98A2B3",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5997 94.4688H36.3997C34.0065 94.4688 32.0664 96.4088 32.0664 98.8021V105.735C32.0664 108.129 34.0065 110.069 36.3997 110.069H93.5997C95.993 110.069 97.9331 108.129 97.9331 105.735V98.8021C97.9331 96.4088 95.993 94.4688 93.5997 94.4688Z",
    fill: "#EAECF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9335 27.7302C47.8481 27.7302 49.4001 26.1781 49.4001 24.2635C49.4001 22.349 47.8481 20.7969 45.9335 20.7969C44.0189 20.7969 42.4668 22.349 42.4668 24.2635C42.4668 26.1781 44.0189 27.7302 45.9335 27.7302Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9999 27.7302C66.9145 27.7302 68.4665 26.1781 68.4665 24.2635C68.4665 22.349 66.9145 20.7969 64.9999 20.7969C63.0853 20.7969 61.5332 22.349 61.5332 24.2635C61.5332 26.1781 63.0853 27.7302 64.9999 27.7302Z",
    fill: "#98A2B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0682 27.7302C85.9828 27.7302 87.5349 26.1781 87.5349 24.2635C87.5349 22.349 85.9828 20.7969 84.0682 20.7969C82.1536 20.7969 80.6016 22.349 80.6016 24.2635C80.6016 26.1781 82.1536 27.7302 84.0682 27.7302Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5326 76.2682C76.9258 76.2682 78.8659 74.3281 78.8659 71.9349C78.8659 69.5417 76.9258 67.6016 74.5326 67.6016C72.1393 67.6016 70.1992 69.5417 70.1992 71.9349C70.1992 74.3281 72.1393 76.2682 74.5326 76.2682Z",
    fill: "#EAECF0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9191 90.4554C77.2257 90.4554 76.5784 90.4554 75.989 90.4181C75.2631 90.369 74.5648 90.1206 73.9709 89.7003C73.377 89.2799 72.9106 88.7039 72.6229 88.0356L68.9664 80.8094C68.6982 80.4971 68.5643 80.0915 68.5939 79.681C68.6234 79.2704 68.814 78.8882 69.1241 78.6176C69.3782 78.4134 69.6952 78.3034 70.0211 78.3064C70.2611 78.3134 70.4967 78.3724 70.7117 78.4792C70.9268 78.586 71.116 78.7382 71.2665 78.9252L72.9271 81.1916L72.9522 81.221V72.6107C72.9522 72.1835 73.1219 71.7738 73.424 71.4718C73.726 71.1697 74.1357 71 74.5629 71C74.9901 71 75.3998 71.1697 75.7019 71.4718C76.0039 71.7738 76.1736 72.1835 76.1736 72.6107V78.244C76.1549 78.0367 76.1796 77.8278 76.2461 77.6306C76.3126 77.4334 76.4194 77.2522 76.5598 77.0985C76.7002 76.9449 76.8711 76.8221 77.0616 76.7382C77.252 76.6542 77.4579 76.6109 77.666 76.6109C77.8742 76.6109 78.08 76.6542 78.2705 76.7382C78.4609 76.8221 78.6318 76.9449 78.7722 77.0985C78.9126 77.2522 79.0194 77.4334 79.0859 77.6306C79.1524 77.8278 79.1771 78.0367 79.1584 78.244V79.4184C79.1397 79.2111 79.1644 79.0022 79.2309 78.8049C79.2974 78.6077 79.4042 78.4265 79.5446 78.2728C79.685 78.1192 79.8559 77.9965 80.0464 77.9125C80.2368 77.8286 80.4427 77.7852 80.6508 77.7852C80.859 77.7852 81.0648 77.8286 81.2553 77.9125C81.4457 77.9965 81.6166 78.1192 81.757 78.2728C81.8974 78.4265 82.0042 78.6077 82.0707 78.8049C82.1372 79.0022 82.1619 79.2111 82.1432 79.4184V80.3232C82.1245 80.1159 82.1492 79.907 82.2157 79.7097C82.2822 79.5125 82.389 79.3313 82.5294 79.1776C82.6698 79.024 82.8407 78.9013 83.0312 78.8173C83.2216 78.7334 83.4275 78.69 83.6356 78.69C83.8438 78.69 84.0496 78.7334 84.2401 78.8173C84.4305 78.9013 84.6014 79.024 84.7418 79.1776C84.8822 79.3313 84.989 79.5125 85.0555 79.7097C85.122 79.907 85.1467 80.1159 85.128 80.3232V85.8152C85.0985 87.5044 84.335 90.3522 81.6492 90.3522C81.4542 90.3609 79.8023 90.4562 77.9225 90.4562L77.9191 90.4554Z",
    fill: "#98A2B3",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4723_27838",
    x: 17.4004,
    y: 28.2656,
    width: 95.1992,
    height: 104.734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4723_27838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4723_27838",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4723_27838",
    x1: 65,
    y1: 0,
    x2: 65,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectViewId);
export default __webpack_public_path__ + "static/media/SelectViewId.2540dde30fb5aafca9de6601e92928dd.svg";
export { ForwardRef as ReactComponent };